import { Outlet } from 'react-router-dom';
import { AccessibilityMenu } from '@semply/theme/AccessibilityMenu';
import { useEstSombre } from '@semply/theme/react';
import { BANNIERE } from '@semply/theme/sombre';
import { a11y, theme } from '../theme';

export function AuthLayout() {
  // Bannière de la suite (03/10/2026) : `banner-dark.svg` en sombre.
  const sombre = useEstSombre();
  return (
    <main className="auth-shell">
      <div>
        <div className="brand">
          <img className="brand-logo" src={sombre ? BANNIERE.sombre : BANNIERE.clair} alt="SEmply" />
        </div>
        <Outlet />
        {/* Sous la carte et non dedans : l'apparence et l'accessibilité sont
            des réglages du navigateur, pas une étape de la connexion. Le même
            menu que dans les produits de la suite (il remplace le seul
            sélecteur Clair/Sombre) ; il s'ouvre vers le haut, la commande
            étant en bas de page. */}
        <div className="auth-footer">
          <AccessibilityMenu theme={theme} a11y={a11y} className="a11y-menu-up" />
        </div>
      </div>
    </main>
  );
}
